import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "p-4 pb-0" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-4 p-4" }
const _hoisted_4 = { class: "flex gap-2" }

import { Ref, ref } from 'vue';
import { Composer, useI18n } from 'vue-i18n';
import { LinkIcon } from '@/enums/link-icon';
import { useLocationStore } from '@/stores/location';
import { usePreferencesStore } from '@/stores/preferences';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppLinkIcon from '@/components/Base/AppLinkIcon.vue';
import AppLogo from '@/components/Base/AppLogo.vue';
import CategorySidemenuHeaderSection from '@/components/CategorySidemenu/CategorySidemenuHeader/CategorySidemenuHeaderSection.vue';
import FieldLanguageSelect from '@/components/Fields/FieldLanguageSelect.vue';
import FieldRegionSelect from '@/components/Fields/FieldRegionSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySidemenuHeader',
  setup(__props) {

const translate = useInject(TranslateKey);
const preferencesStore = usePreferencesStore();
const locationStore = useLocationStore();
const i18n: Composer = useI18n();

const region: Ref<string> = ref(preferencesStore.region);
const language: Ref<string> = ref(preferencesStore.language);

const updateRegionInStore = (): void => {
  preferencesStore.region = region.value;
  locationStore.reloadLayout();
};

const updateLanguageInStore = (): void => {
  preferencesStore.setLanguage(i18n, language.value);
  locationStore.reloadLayout();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppLogo)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CategorySidemenuHeaderSection, {
        title: _unref(translate)('header.language')
      }, {
        default: _withCtx(() => [
          _createVNode(FieldLanguageSelect, {
            modelValue: language.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
              updateLanguageInStore
            ]
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(CategorySidemenuHeaderSection, {
        title: _unref(translate)('header.region')
      }, {
        default: _withCtx(() => [
          _createVNode(FieldRegionSelect, {
            modelValue: region.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((region).value = $event)),
              updateRegionInStore
            ]
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(CategorySidemenuHeaderSection, {
        title: _unref(translate)('header.more')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AppLinkIcon, {
              name: _unref(LinkIcon).LEGAL
            }, null, 8, ["name"]),
            _createVNode(AppLinkIcon, {
              name: _unref(LinkIcon).GITHUB
            }, null, 8, ["name"])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}
}

})